export default __webpack_public_path__ + "static/media/exclusive-tour.e380f364.jpg";